import { taxCodesDetails } from "@/shared/utils/taxCodeDetails.utils";
import i18n from "@/app/plugins/i18n";
import { TaxBehavior } from "@/shared/enums/taxes.enum";
import { TaxCodes } from "@/shared/enums/taxCodes.enum";
import { useAccountStore } from "@/account/stores/account";
import { hasFeatureAccess } from "./feature.utils";
import { PlatformFeature } from "@/shared/enums/feature.enum";
import { computed } from "vue";

type TaxCodeDetail = (typeof taxCodesDetails)[keyof typeof taxCodesDetails];

export const getGroupedTaxCodes = (): Record<string, Record<string, TaxCodeDetail>> => {
  const groupedByType: Record<string, Record<string, TaxCodeDetail>> = {};
  const generalCategory = [
    TaxCodes.GENERAL_TANGIBLE_GOODS,
    TaxCodes.GENERAL_SERVICES,
    TaxCodes.GENERAL_ELECTRONIC_SERVICES,
  ];

  for (const [id, code] of Object.entries(taxCodesDetails)) {
    // Skip the default tax code
    if (id === TaxCodes.ACCOUNT_DEFAULT) continue;

    // Check if the code ID is in generalCategory
    const isGeneral = generalCategory.includes(id as TaxCodes);
    const type = isGeneral ? "general" : code.type;

    if (!groupedByType[type]) {
      groupedByType[type] = {};
    }

    groupedByType[type][id] = {
      ...code, // retains all fields including `type`
    };
  }

  return groupedByType;
};

export const taxBehaviorOptions = [
  // Keep this here for now, for some reason UNSPECIFIED is not part of the taxBehavior enum on stripe's tax default settings
  { title: i18n.global.t("product.taxBehavior.unspecified.label"), value: TaxBehavior.UNSPECIFIED },
  { title: i18n.global.t("product.taxBehavior.inclusive.label"), value: TaxBehavior.INCLUSIVE },
  { title: i18n.global.t("product.taxBehavior.exclusive.label"), value: TaxBehavior.EXCLUSIVE },
  // { title: i18n.global.t('product.taxBehavior.inferredByCurrency.label'), value: TaxBehavior.INFERRED_BY_CURRENCY },
];

// Check if taxes are enabled
export const isTaxesEnabled = computed(() => {
  return (
    hasFeatureAccess(PlatformFeature.TAXES) &&
    (useAccountStore().account?.accountSettings?.taxes?.enabled ?? false)
  );
});
